import { CLAUSE_KEYWORD_BOUNDARY } from '../configs';

export interface IBuildFromQueryParams {
  sources: string[];
}

const build = (sources: string[]) => `FROM ${sources.join(', ')}`;

const parse = (query: string): string[] => {
  const match = query.match(
    new RegExp(`\\bFROM\\s+([\\s\\S]+?)(?=\\s+(?:${CLAUSE_KEYWORD_BOUNDARY})\\b)`, 'i'),
  );
  if (!match) return [];
  return match[1]
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};

export { build as buildFromQuery, parse as parseFromQuery };
